import React from "react";
import { ReactComponent as IconCircleClose } from "assets/svg/icon-circle-close.svg";

export const CircleClose: React.FC = () => <IconCircleClose />;

export default CircleClose;
